import React from 'react';
import { BsDiscord, BsTwitch, BsYoutube, BsTiktok, BsFacebook, BsSteam } from 'react-icons/bs';
import { FaStar, FaCheck, FaTimes } from 'react-icons/fa';
import './WishlistGamePage.css';

// Lazy load Account service only when needed
let Account: typeof import('./services/Account').Account;

// Language translations
const translations: Record<string, Record<string, string>> = {
  en: {
    beginQuest: "Begin Your Quest!",
    freeToPlay: "FREE",
    toPlay: "TO PLAY",
    upTo: "Up to",
    players: "PLAYERS",
    playOn: "Play on:",
    startQuest: "START QUEST",
    quest: "Quest",
    of: "of",
    boost: "BOOST!",
    boostPrompt: "Every car has a boost! Tap the button to blast past your rivals!",
    boostActivated: "WOOSH! Use boost to overtake and leave opponents in the dust!",
    pressBoost: "Press BOOST to start!",
    ram: "RAM!",
    ramPrompt: "Smash into opponents to knock them off course! Tap RAM to attack!",
    ramActivated: "CRASH! Ram enemies to slow them down and take the lead!",
    pressRam: "Press RAM to attack!",
    special: "SPECIAL ABILITY!",
    specialPrompt: "Each driver has a unique special power! Activate it to dominate!",
    specialActivated: "AMAZING! Use your driver's special ability to turn the tide!",
    pressSpecial: "Press SPECIAL to unleash!",
    completeQuest: "COMPLETE QUEST",
    completed: "✓ COMPLETED",
    almostThere: "🎉 ALMOST THERE! 🎉",
    bonusXpHint: "+100 XP to complete your quest!",
    claimWelcomePack: "Claim your FREE Welcome Pack!",
    doYouHaveSteam: "Do you have Steam?",
    yes: "YES",
    no: "NO",
    finalQuestSteam: "Final Quest: Wishlist on Steam!",
    wishlistOnSteam: "🎮 Wishlist on Steam",
    finalQuestCommunity: "Final Quest: Join the Community!",
    emailDescription: "Enter your email to claim your Welcome Pack when we launch!",
    enterEmail: "Enter your email",
    createAccount: "Create Account",
    accountCreated: "✓ Account created!",
    notifyYou: "We'll notify you at",
    joinDiscord: "Join Discord Server",
    selectLanguage: "Select Your Language",
    welcomeMessage: "Welcome! 🎮",
    pleaseEnterEmail: "Please enter your email",
    invalidEmail: "Please enter a valid email address",
    failedToCreate: "Failed to create account. Please try again.",
    somethingWrong: "Something went wrong. Please try again."
  },
  fil: {
    beginQuest: "Simulan ang Iyong Quest!",
    freeToPlay: "LIBRE",
    toPlay: "MAGLARO",
    upTo: "Hanggang",
    players: "MANLALARO",
    playOn: "Maglaro sa:",
    startQuest: "SIMULAN ANG QUEST",
    quest: "Quest",
    of: "ng",
    boost: "BOOST!",
    boostPrompt: "Bawat kotse ay may boost! I-tap ang button para lampasan ang mga kalaban!",
    boostActivated: "WOOSH! Gamitin ang boost para umarangkada at iwanan sa alikabok ang mga kalaban!",
    pressBoost: "Pindutin ang BOOST para magsimula!",
    ram: "RAM!",
    ramPrompt: "Banggain ang mga kalaban para mawala sa landas! I-tap ang RAM para umatake!",
    ramActivated: "CRASH! I-ram ang mga kalaban para pabagalin sila at manguna!",
    pressRam: "Pindutin ang RAM para umatake!",
    special: "ESPESYAL NA ABILIDAD!",
    specialPrompt: "Bawat driver ay may natatanging kapangyarihan! I-activate para manalo!",
    specialActivated: "AMAZING! Gamitin ang espesyal na abilidad ng iyong driver!",
    pressSpecial: "Pindutin ang SPECIAL para ilabas!",
    completeQuest: "KUMPLETUHIN ANG QUEST",
    completed: "✓ NAKUMPLETO",
    almostThere: "🎉 MALAPIT NA! 🎉",
    bonusXpHint: "+100 XP para makumpleto ang quest mo!",
    claimWelcomePack: "Kunin ang iyong LIBRENG Welcome Pack!",
    doYouHaveSteam: "Mayroon ka bang Steam?",
    yes: "OO",
    no: "WALA",
    finalQuestSteam: "Huling Quest: I-Wishlist sa Steam!",
    wishlistOnSteam: "🎮 I-Wishlist sa Steam",
    finalQuestCommunity: "Huling Quest: Sumali sa Komunidad!",
    emailDescription: "Ilagay ang iyong email para makuha ang Welcome Pack kapag nag-launch kami!",
    enterEmail: "Ilagay ang iyong email",
    createAccount: "Gumawa ng Account",
    accountCreated: "✓ Nagawa na ang account!",
    notifyYou: "Aabisuhan ka namin sa",
    joinDiscord: "Sumali sa Discord Server",
    selectLanguage: "Piliin ang Iyong Wika",
    welcomeMessage: "Maligayang pagdating! 🎮",
    pleaseEnterEmail: "Pakiusap ilagay ang iyong email",
    invalidEmail: "Pakiusap maglagay ng valid na email address",
    failedToCreate: "Hindi nagawa ang account. Pakisubukan ulit.",
    somethingWrong: "May mali. Pakisubukan ulit."
  },
  pt: {
    beginQuest: "Comece sua Missão!",
    freeToPlay: "GRÁTIS",
    toPlay: "PARA JOGAR",
    upTo: "Até",
    players: "JOGADORES",
    playOn: "Jogue em:",
    startQuest: "INICIAR MISSÃO",
    quest: "Missão",
    of: "de",
    boost: "TURBO!",
    boostPrompt: "Todo carro tem turbo! Toque no botão para ultrapassar seus rivais!",
    boostActivated: "VRUM! Use o turbo para ultrapassar e deixar os oponentes na poeira!",
    pressBoost: "Pressione TURBO para começar!",
    ram: "COLIDIR!",
    ramPrompt: "Bata nos oponentes para tirá-los do caminho! Toque COLIDIR para atacar!",
    ramActivated: "CRASH! Colida nos inimigos para atrasá-los e assumir a liderança!",
    pressRam: "Pressione COLIDIR para atacar!",
    special: "HABILIDADE ESPECIAL!",
    specialPrompt: "Cada piloto tem um poder único! Ative para dominar!",
    specialActivated: "INCRÍVEL! Use a habilidade especial do seu piloto para virar o jogo!",
    pressSpecial: "Pressione ESPECIAL para liberar!",
    completeQuest: "COMPLETAR MISSÃO",
    completed: "✓ COMPLETADO",
    almostThere: "🎉 QUASE LÁ! 🎉",
    bonusXpHint: "+100 XP para completar sua missão!",
    claimWelcomePack: "Resgate seu Pacote de Boas-Vindas GRÁTIS!",
    doYouHaveSteam: "Você tem Steam?",
    yes: "SIM",
    no: "NÃO",
    finalQuestSteam: "Missão Final: Adicione à Lista de Desejos na Steam!",
    wishlistOnSteam: "🎮 Adicionar à Lista de Desejos",
    finalQuestCommunity: "Missão Final: Entre na Comunidade!",
    emailDescription: "Digite seu email para receber seu Pacote de Boas-Vindas quando lançarmos!",
    enterEmail: "Digite seu email",
    createAccount: "Criar Conta",
    accountCreated: "✓ Conta criada!",
    notifyYou: "Vamos notificar você em",
    joinDiscord: "Entrar no Servidor Discord",
    selectLanguage: "Escolha seu Idioma",
    welcomeMessage: "Bem-vindo! 🎮",
    pleaseEnterEmail: "Por favor, digite seu email",
    invalidEmail: "Por favor, digite um email válido",
    failedToCreate: "Falha ao criar conta. Tente novamente.",
    somethingWrong: "Algo deu errado. Tente novamente."
  },
  es: {
    beginQuest: "¡Comienza tu Misión!",
    freeToPlay: "GRATIS",
    toPlay: "PARA JUGAR",
    upTo: "Hasta",
    players: "JUGADORES",
    playOn: "Juega en:",
    startQuest: "INICIAR MISIÓN",
    quest: "Misión",
    of: "de",
    boost: "¡TURBO!",
    boostPrompt: "¡Todos los autos tienen turbo! ¡Toca el botón para adelantar a tus rivales!",
    boostActivated: "¡VROOM! ¡Usa el turbo para adelantar y dejar a los oponentes en el polvo!",
    pressBoost: "¡Presiona TURBO para empezar!",
    ram: "¡EMBESTIR!",
    ramPrompt: "¡Choca contra los oponentes para sacarlos del camino! ¡Toca EMBESTIR para atacar!",
    ramActivated: "¡CRASH! ¡Embiste a los enemigos para frenarlos y tomar la delantera!",
    pressRam: "¡Presiona EMBESTIR para atacar!",
    special: "¡HABILIDAD ESPECIAL!",
    specialPrompt: "¡Cada piloto tiene un poder único! ¡Actívalo para dominar!",
    specialActivated: "¡INCREÍBLE! ¡Usa la habilidad especial de tu piloto para cambiar el juego!",
    pressSpecial: "¡Presiona ESPECIAL para liberar!",
    completeQuest: "COMPLETAR MISIÓN",
    completed: "✓ COMPLETADO",
    almostThere: "🎉 ¡CASI LISTO! 🎉",
    bonusXpHint: "+100 XP para completar tu misión!",
    claimWelcomePack: "¡Reclama tu Pack de Bienvenida GRATIS!",
    doYouHaveSteam: "¿Tienes Steam?",
    yes: "SÍ",
    no: "NO",
    finalQuestSteam: "Misión Final: ¡Añadir a Lista de Deseados en Steam!",
    wishlistOnSteam: "🎮 Añadir a Lista de Deseados",
    finalQuestCommunity: "Misión Final: ¡Únete a la Comunidad!",
    emailDescription: "¡Ingresa tu email para recibir tu Pack de Bienvenida cuando lancemos!",
    enterEmail: "Ingresa tu email",
    createAccount: "Crear Cuenta",
    accountCreated: "✓ ¡Cuenta creada!",
    notifyYou: "Te notificaremos en",
    joinDiscord: "Unirse al Servidor Discord",
    selectLanguage: "Selecciona tu Idioma",
    welcomeMessage: "¡Bienvenido! 🎮",
    pleaseEnterEmail: "Por favor ingresa tu email",
    invalidEmail: "Por favor ingresa un email válido",
    failedToCreate: "Error al crear cuenta. Intenta de nuevo.",
    somethingWrong: "Algo salió mal. Intenta de nuevo."
  },
  zh: {
    beginQuest: "开始你的任务！",
    freeToPlay: "免费",
    toPlay: "游玩",
    upTo: "最多",
    players: "玩家",
    playOn: "在以下平台玩：",
    startQuest: "开始任务",
    quest: "任务",
    of: "/",
    boost: "加速！",
    boostPrompt: "每辆车都有加速！点击按钮超越对手！",
    boostActivated: "嗖！使用加速超车，把对手甩在身后！",
    pressBoost: "按下加速开始！",
    ram: "撞击！",
    ramPrompt: "撞击对手让他们偏离赛道！点击撞击进行攻击！",
    ramActivated: "砰！撞击敌人减慢他们的速度，夺取领先！",
    pressRam: "按下撞击进行攻击！",
    special: "特殊技能！",
    specialPrompt: "每个车手都有独特的特殊能力！激活它来统治比赛！",
    specialActivated: "太棒了！使用你车手的特殊技能扭转局势！",
    pressSpecial: "按下特殊释放技能！",
    completeQuest: "完成任务",
    completed: "✓ 已完成",
    almostThere: "🎉 快完成了！🎉",
    bonusXpHint: "+100 经验值完成你的任务！",
    claimWelcomePack: "领取你的免费欢迎礼包！",
    doYouHaveSteam: "你有Steam吗？",
    yes: "有",
    no: "没有",
    finalQuestSteam: "最终任务：在Steam添加愿望单！",
    wishlistOnSteam: "🎮 添加到愿望单",
    finalQuestCommunity: "最终任务：加入社区！",
    emailDescription: "输入你的邮箱，游戏上线时领取欢迎礼包！",
    enterEmail: "输入你的邮箱",
    createAccount: "创建账户",
    accountCreated: "✓ 账户已创建！",
    notifyYou: "我们会通知你",
    joinDiscord: "加入Discord服务器",
    selectLanguage: "选择语言",
    welcomeMessage: "欢迎！🎮",
    pleaseEnterEmail: "请输入你的邮箱",
    invalidEmail: "请输入有效的邮箱地址",
    failedToCreate: "创建账户失败，请重试。",
    somethingWrong: "出错了，请重试。"
  },
  ja: {
    beginQuest: "クエストを始めよう！",
    freeToPlay: "無料",
    toPlay: "プレイ",
    upTo: "最大",
    players: "プレイヤー",
    playOn: "プレイ可能：",
    startQuest: "クエスト開始",
    quest: "クエスト",
    of: "/",
    boost: "ブースト！",
    boostPrompt: "すべての車にブーストあり！ボタンをタップしてライバルを追い越そう！",
    boostActivated: "ビューン！ブーストで追い越して、相手を置き去りに！",
    pressBoost: "ブーストを押してスタート！",
    ram: "ラム！",
    ramPrompt: "相手にぶつかってコースから外そう！ラムをタップして攻撃！",
    ramActivated: "ガシャン！敵にぶつかって減速させ、リードを奪え！",
    pressRam: "ラムを押して攻撃！",
    special: "スペシャルアビリティ！",
    specialPrompt: "各ドライバーには独自の特殊能力あり！発動して支配しよう！",
    specialActivated: "すごい！ドライバーの特殊能力で流れを変えろ！",
    pressSpecial: "スペシャルを押して発動！",
    completeQuest: "クエスト完了",
    completed: "✓ 完了",
    almostThere: "🎉 もう少し！🎉",
    bonusXpHint: "+100 XPでクエスト完了！",
    claimWelcomePack: "無料ウェルカムパックをゲット！",
    doYouHaveSteam: "Steamを持っていますか？",
    yes: "はい",
    no: "いいえ",
    finalQuestSteam: "最終クエスト：Steamでウィッシュリストに追加！",
    wishlistOnSteam: "🎮 ウィッシュリストに追加",
    finalQuestCommunity: "最終クエスト：コミュニティに参加！",
    emailDescription: "メールを入力してローンチ時にウェルカムパックを受け取ろう！",
    enterEmail: "メールアドレスを入力",
    createAccount: "アカウント作成",
    accountCreated: "✓ アカウント作成完了！",
    notifyYou: "こちらにお知らせします",
    joinDiscord: "Discordサーバーに参加",
    selectLanguage: "言語を選択",
    welcomeMessage: "ようこそ！🎮",
    pleaseEnterEmail: "メールを入力してください",
    invalidEmail: "有効なメールアドレスを入力してください",
    failedToCreate: "アカウント作成に失敗しました。もう一度お試しください。",
    somethingWrong: "エラーが発生しました。もう一度お試しください。"
  }
};

// Language options with flag images from flagcdn.com (w160 for crisp display)
const languageOptions = [
  { code: 'en', name: 'English', flag: 'https://flagcdn.com/w160/us.png', flagAlt: 'US Flag' },
  { code: 'fil', name: 'Filipino', flag: 'https://flagcdn.com/w160/ph.png', flagAlt: 'Philippines Flag' },
  { code: 'pt', name: 'Português', flag: 'https://flagcdn.com/w160/br.png', flagAlt: 'Brazil Flag' },
  { code: 'es', name: 'Español', flag: 'https://flagcdn.com/w160/es.png', flagAlt: 'Spain Flag' },
  { code: 'zh', name: '中文', flag: 'https://flagcdn.com/w160/cn.png', flagAlt: 'China Flag' },
  { code: 'ja', name: '日本語', flag: 'https://flagcdn.com/w160/jp.png', flagAlt: 'Japan Flag' }
];

interface WishlistGamePageState {
  currentScreen: number;
  xp: number;
  questsCompleted: boolean[];
  abilityActivated: boolean[]; // Track if ability button was clicked
  questReady: boolean[]; // Track if quest is ready to complete
  email: string;
  emailSubmitted: boolean;
  emailError: string;
  showXpPopup: boolean;
  xpPopupAmount: number;
  showSteamPopup: boolean;
  hasSteam: boolean | null; // null = not answered, true = yes, false = no
  language: string;
  showLanguageModal: boolean;
}

class WishlistGamePage extends React.Component<{}, WishlistGamePageState> {
  private videoRefs: (HTMLVideoElement | null)[] = [];

  constructor(props: {}) {
    super(props);
    
    // Check for saved language preference
    const savedLanguage = localStorage.getItem('preferredLanguage');
    
    this.state = {
      currentScreen: 0,
      xp: 0,
      questsCompleted: [false, false, false],
      abilityActivated: [false, false, false], // Track ability activations
      questReady: [false, false, false], // Track if quest is ready to complete
      email: '',
      emailSubmitted: false,
      emailError: '',
      showXpPopup: false,
      xpPopupAmount: 0,
      showSteamPopup: false,
      hasSteam: null,
      language: savedLanguage || 'en',
      showLanguageModal: !savedLanguage, // Show modal if no saved preference
    };
  }

  componentDidMount() {
    // Track page abandonment
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  }

  // Get translated text
  t = (key: string): string => {
    const lang = translations[this.state.language] || translations.en;
    return lang[key] || translations.en[key] || key;
  }

  // Handle language selection
  handleLanguageSelect = (langCode: string) => {
    const previousLang = this.state.language;
    const langOption = languageOptions.find(l => l.code === langCode);
    
    this.setState({ 
      language: langCode, 
      showLanguageModal: false 
    });
    localStorage.setItem('preferredLanguage', langCode);
    
    // Track language selection with DataFast
    this.trackEvent('language_selected', { 
      language: langCode,
      language_name: langOption?.name || langCode,
      previous_language: previousLang,
      is_change: previousLang !== langCode
    });
    
    // Track specific language event for easier filtering
    this.trackEvent(`language_${langCode}`);
  }

  // Open language modal
  openLanguageModal = () => {
    this.setState({ showLanguageModal: true });
    this.trackEvent('language_modal_opened', { current_language: this.state.language });
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }

  handleBeforeUnload = () => {
    this.trackEvent(`quest_abandoned_screen_${this.state.currentScreen}`);
  };

  trackEvent = (eventName: string, data?: any) => {
    if (typeof window !== 'undefined' && (window as any).datafast) {
      (window as any).datafast(eventName, data);
      console.log('📊 Tracked:', eventName, data);
    }
  };


  goToScreen = (screen: number) => {
    if (screen >= 0 && screen <= 4) {
      const previousScreen = this.state.currentScreen;
      
      // Show Steam popup when entering final screen
      if (screen === 4 && this.state.hasSteam === null) {
        this.setState({ currentScreen: screen, showSteamPopup: true });
      } else {
        this.setState({ currentScreen: screen });
      }
      
      if (screen > previousScreen) {
        this.trackEvent(`clicked_next_quest_${previousScreen}`);
      } else if (screen < previousScreen) {
        this.trackEvent(`clicked_back_quest_${previousScreen}`);
      }
    }
  };

  handleSteamAnswer = (hasSteam: boolean) => {
    this.setState({ 
      hasSteam, 
      showSteamPopup: false 
    });
    // Track overall answer event
    this.trackEvent('steam_answer', { has_steam: hasSteam });
    // Track specific yes/no event
    this.trackEvent(hasSteam ? 'steam_yes' : 'steam_no');
  };

  activateAbility = (questIndex: number) => {
    if (this.state.abilityActivated[questIndex]) return;

    const newActivated = [...this.state.abilityActivated];
    newActivated[questIndex] = true;
    this.setState({ abilityActivated: newActivated });

    // Play the video
    const video = this.videoRefs[questIndex];
    if (video) {
      video.play();
    }

    // Make quest ready to complete after 0.5 seconds
    setTimeout(() => {
      const newReady = [...this.state.questReady];
      newReady[questIndex] = true;
      this.setState({ questReady: newReady });
    }, 500);

    // Track the ability activation
    const abilityNames = ['boost', 'ram', 'special'];
    this.trackEvent(`ability_activated_${abilityNames[questIndex]}`);
  };

  startQuest = () => {
    this.trackEvent('quest_started');
    // Award XP for starting
    this.setState({
      xp: 100,
      showXpPopup: true,
      xpPopupAmount: 100,
    });
    setTimeout(() => {
      this.setState({ showXpPopup: false });
    }, 1500);
    this.goToScreen(1);
  };

  completeQuest = (questIndex: number) => {
    if (this.state.questsCompleted[questIndex]) return;

    const newQuestsCompleted = [...this.state.questsCompleted];
    newQuestsCompleted[questIndex] = true;

    this.setState({
      questsCompleted: newQuestsCompleted,
      xp: this.state.xp + 100,
      showXpPopup: true,
      xpPopupAmount: 100,
    });

    this.trackEvent(`quest_${questIndex + 1}_completed`);

    // Hide XP popup after animation
    setTimeout(() => {
      this.setState({ showXpPopup: false });
    }, 1500);

    // Auto-advance to next screen after a brief delay
    setTimeout(() => {
      if (questIndex < 2) {
        this.goToScreen(questIndex + 2);
      } else {
        // Final quest completed, go to conversion screen
        this.trackEvent('quest_fully_completed');
        this.goToScreen(4);
      }
    }, 800);
  };

  // Check if we're in a webview context
  isInWebView = () => {
    const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
    return (
      /wv/.test(ua) ||
      /(iPhone|iPod|iPad)(?!.*Safari)/i.test(ua) ||
      /FBAN|FBAV/.test(ua) ||
      /Instagram/.test(ua) ||
      /Twitter/.test(ua) ||
      /LinkedInApp/.test(ua) ||
      /RedditApp/.test(ua) ||
      typeof (window as any).ReactNativeWebView !== 'undefined'
    );
  };

  handleDiscordClick = () => {
    const discordUrl = 'https://discord.gg/qpP85YSjAT';
    
    if (this.isInWebView()) {
      window.location.href = `discord://discord.gg/qpP85YSjAT`;
      setTimeout(() => {
        window.location.href = discordUrl;
      }, 500);
    } else {
      const newWindow = window.open(discordUrl, '_blank');
      if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
        window.location.href = discordUrl;
      }
    }
  };

  validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ email: e.target.value, emailError: '' });
  };

  handleEmailFocus = () => {
    // Pre-load Account service
    if (!Account) {
      import('./services/Account').then(module => {
        Account = module.Account;
      }).catch(console.error);
    }
  };

  handleEmailSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    const { email } = this.state;
    
    if (!email) {
      this.setState({ emailError: this.t('pleaseEnterEmail') });
      return;
    }

    if (!this.validateEmail(email)) {
      this.setState({ emailError: this.t('invalidEmail') });
      return;
    }

    try {
      if (!Account) {
        const AccountModule = await import('./services/Account');
        Account = AccountModule.Account;
      }

      const customId = `email:${email}`;
      const result = await Account.loginWithCustomId(customId, true);
      
      if (result.success) {
        this.trackEvent('quest_account_created');
        this.trackEvent('sign_up', { method: 'email' });
        localStorage.setItem('guestEmail', email);
        
        // Award bonus XP for completing final quest
        this.setState({ 
          emailSubmitted: true,
          emailError: '',
          xp: 100,
          showXpPopup: true,
          xpPopupAmount: 25,
        });
        
        // Hide XP popup after animation
        setTimeout(() => {
          this.setState({ showXpPopup: false });
        }, 1500);
      } else {
        this.setState({ 
          emailError: this.t('failedToCreate')
        });
      }
    } catch (error) {
      this.setState({ 
        emailError: this.t('somethingWrong')
      });
      console.error('Email submission error:', error);
    }
  };

  renderXpBar = () => {
    const { xp, showXpPopup, xpPopupAmount } = this.state;
    const maxXp = 500;
    const percentage = (xp / maxXp) * 100;

    return (
      <div className="quest-xp-container">
        <div className="quest-xp-bar">
          <div 
            className="quest-xp-fill" 
            style={{ width: `${percentage}%` }}
          />
        </div>
        <div className="quest-xp-text">
          <FaStar className="xp-star" />
          {xp} / {maxXp} XP
        </div>
        {showXpPopup && (
          <div className="xp-popup">+{xpPopupAmount} XP!</div>
        )}
      </div>
    );
  };

  renderProgressDots = () => {
    const { currentScreen } = this.state;
    const totalScreens = 5;
    const currentLang = languageOptions.find(l => l.code === this.state.language);

    return (
      <div className="quest-bottom-bar">
        {/* Language toggle on left */}
        <button 
          className="language-toggle-bottom"
          onClick={this.openLanguageModal}
          title={this.t('selectLanguage')}
        >
          <img 
            src={currentLang?.flag || 'https://flagcdn.com/w80/us.png'} 
            alt={currentLang?.flagAlt || 'Flag'}
            className="bottom-flag-img"
          />
        </button>

        {/* Progress dots in center */}
        <div className="quest-progress-dots">
          {Array.from({ length: totalScreens }, (_, i) => (
            <div 
              key={i}
              className={`progress-dot ${i === currentScreen ? 'active' : ''} ${i < currentScreen ? 'completed' : ''}`}
            />
          ))}
        </div>

        {/* Empty spacer for balance */}
        <div className="bottom-spacer"></div>
      </div>
    );
  };

  renderScreen0 = () => (
    <div className="quest-screen screen-welcome">
      <img 
        src="/images/logo-big.png" 
        alt="Nova Rally Logo" 
        className="quest-logo"
      />
      
      <h1 className="quest-main-title">{this.t('beginQuest')}</h1>
      
      <div className="quest-video-container">
        <video
          src="/videos/Mp4%20Trim.webm"
          autoPlay
          loop
          muted
          playsInline
          className="quest-video"
        />
      </div>

      <div className="game-highlights">
        <div className="highlight-block">
          <span className="highlight-label-top">&nbsp;</span>
          <span className="highlight-number">{this.t('freeToPlay')}</span>
          <span className="highlight-label">{this.t('toPlay')}</span>
        </div>
        <div className="highlight-block">
          <span className="highlight-label-top">{this.t('upTo')}</span>
          <span className="highlight-number">100</span>
          <span className="highlight-label">{this.t('players')}</span>
        </div>
        <div className="highlight-block">
          <span className="highlight-label-top">{this.t('playOn')}</span>
          <div className="stream-icons">
            <BsTwitch className="stream-icon twitch" />
            <BsYoutube className="stream-icon youtube" />
            <BsTiktok className="stream-icon tiktok" />
            <BsFacebook className="stream-icon facebook" />
          </div>
          <span className="highlight-label">&nbsp;</span>
        </div>
      </div>

      <button 
        className="quest-start-button pulse-animation"
        onClick={this.startQuest}
      >
        <FaStar className="button-icon" />
        {this.t('startQuest')}
        <FaStar className="button-icon" />
      </button>
    </div>
  );

  renderScreen1 = () => {
    const activated = this.state.abilityActivated[0];
    const ready = this.state.questReady[0];
    const completed = this.state.questsCompleted[0];

    return (
      <div className="quest-screen screen-quest">
        <div className="quest-header">
          <span className="quest-number">{this.t('quest')} 1 {this.t('of')} 3</span>
          <h2 className="quest-title">🚀 {this.t('boost')}</h2>
        </div>

        <p className="quest-prompt">
          {!activated 
            ? this.t('boostPrompt')
            : this.t('boostActivated')}
        </p>
        
        <div className="quest-video-container">
          {!activated && <div className="video-overlay">{this.t('pressBoost')}</div>}
          <video
            ref={el => this.videoRefs[0] = el}
            src="/videos/BoostWishlist.mp4"
            loop
            muted
            playsInline
            className={`quest-video ${!activated ? 'video-paused' : ''}`}
          />
        </div>

        {!activated ? (
          <button 
            className="quest-ability-button boost-button pulse-animation"
            onClick={() => this.activateAbility(0)}
          >
            🚀 {this.t('boost')}
          </button>
        ) : ready ? (
          <button 
            className={`quest-complete-button ${completed ? 'completed' : 'glow-animation'}`}
            onClick={() => this.completeQuest(0)}
            disabled={completed}
          >
            {completed ? this.t('completed') : this.t('completeQuest')}
          </button>
        ) : null}
      </div>
    );
  };

  renderScreen2 = () => {
    const activated = this.state.abilityActivated[1];
    const ready = this.state.questReady[1];
    const completed = this.state.questsCompleted[1];

    return (
      <div className="quest-screen screen-quest">
        <div className="quest-header">
          <span className="quest-number">{this.t('quest')} 2 {this.t('of')} 3</span>
          <h2 className="quest-title">💥 {this.t('ram')}</h2>
        </div>

        <p className="quest-prompt">
          {!activated 
            ? this.t('ramPrompt')
            : this.t('ramActivated')}
        </p>
        
        <div className="quest-video-container">
          {!activated && <div className="video-overlay">{this.t('pressRam')}</div>}
          <video
            ref={el => this.videoRefs[1] = el}
            src="/videos/RamWishlist.mp4"
            loop
            muted
            playsInline
            className={`quest-video ${!activated ? 'video-paused' : ''}`}
          />
        </div>

        {!activated ? (
          <button 
            className="quest-ability-button ram-button pulse-animation"
            onClick={() => this.activateAbility(1)}
          >
            💥 {this.t('ram')}
          </button>
        ) : ready ? (
          <button 
            className={`quest-complete-button ${completed ? 'completed' : 'glow-animation'}`}
            onClick={() => this.completeQuest(1)}
            disabled={completed}
          >
            {completed ? this.t('completed') : this.t('completeQuest')}
          </button>
        ) : null}
      </div>
    );
  };

  renderScreen3 = () => {
    const activated = this.state.abilityActivated[2];
    const ready = this.state.questReady[2];
    const completed = this.state.questsCompleted[2];

    return (
      <div className="quest-screen screen-quest">
        <div className="quest-header">
          <span className="quest-number">{this.t('quest')} 3 {this.t('of')} 3</span>
          <h2 className="quest-title">🛡️ {this.t('special')}</h2>
        </div>

        <p className="quest-prompt">
          {!activated 
            ? this.t('specialPrompt')
            : this.t('specialActivated')}
        </p>
        
        <div className="quest-video-container">
          {!activated && <div className="video-overlay">{this.t('pressSpecial')}</div>}
          <video
            ref={el => this.videoRefs[2] = el}
            src="/videos/Dillysmash360p.mp4"
            loop
            muted
            playsInline
            className={`quest-video ${!activated ? 'video-paused' : ''}`}
          />
        </div>

        {!activated ? (
          <button 
            className="quest-ability-button special-button pulse-animation"
            onClick={() => this.activateAbility(2)}
          >
            🛡️ {this.t('special')}
          </button>
        ) : ready ? (
          <button 
            className={`quest-complete-button ${completed ? 'completed' : 'glow-animation'}`}
            onClick={() => this.completeQuest(2)}
            disabled={completed}
          >
            {completed ? this.t('completed') : this.t('completeQuest')}
          </button>
        ) : null}
      </div>
    );
  };

  renderSteamPopup = () => {
    if (!this.state.showSteamPopup) return null;
    
    return (
      <div className="steam-popup-overlay">
        <div className="steam-popup">
          <BsSteam className="steam-popup-icon" />
          <h2 className="steam-popup-title">{this.t('doYouHaveSteam')}</h2>
          <div className="steam-popup-buttons">
            <button 
              className="steam-popup-btn yes-btn"
              onClick={() => this.handleSteamAnswer(true)}
            >
              <BsSteam className="btn-steam-icon" />
              <span>{this.t('yes')}</span>
              <span className="btn-emoji">✅</span>
            </button>
            <button 
              className="steam-popup-btn no-btn"
              onClick={() => this.handleSteamAnswer(false)}
            >
              <div className="steam-crossed">
                <BsSteam className="btn-steam-icon" />
                <div className="cross-line"></div>
              </div>
              <span>{this.t('no')}</span>
              <span className="btn-emoji">❌</span>
            </button>
          </div>
        </div>
      </div>
    );
  };

  renderScreen4 = () => {
    const { hasSteam, emailSubmitted, email, emailError } = this.state;

    return (
      <div className="quest-screen screen-final">
        <div className="quest-complete-celebration">
          <h1 className="celebration-title">{this.t('almostThere')}</h1>
          <div className="celebration-xp">400 / 500 XP</div>
          <p className="bonus-xp-hint">{this.t('bonusXpHint')}</p>
        </div>

        <div className="welcome-pack-display">
          <img 
            src="/images/welcome-pack.png" 
            alt="Welcome Pack" 
            className="welcome-pack-img"
          />
          <p className="welcome-pack-text">{this.t('claimWelcomePack')}</p>
        </div>

        {hasSteam === null ? (
          // Waiting for popup answer
          <div className="final-quest-waiting">
            <p>...</p>
          </div>
        ) : hasSteam ? (
          // Has Steam - show wishlist button
          <>
            <h2 className="final-quest-title">{this.t('finalQuestSteam')}</h2>
            <a 
              href="https://store.steampowered.com/app/2363420/Nova_Rally/?utm_source=wishlist_game&utm_medium=web&utm_campaign=quest&utm_content=final_button#game_area_purchase"
              target="_blank"
              rel="noopener noreferrer"
              className="quest-cta-button steam-cta final-steam-button"
              data-fast-goal="clicked_steam_wishlist_quest"
              onClick={() => this.trackEvent('sign_up', { method: 'steam' })}
            >
              {this.t('wishlistOnSteam')}
            </a>
          </>
        ) : (
          // No Steam - show email signup
          <>
            <h2 className="final-quest-title">{this.t('finalQuestCommunity')}</h2>
            {!emailSubmitted ? (
              <div className="quest-email-section">
                <p className="quest-email-description">
                  {this.t('emailDescription')}
                </p>
                <form onSubmit={this.handleEmailSubmit} className="quest-email-form">
                  <input
                    type="email"
                    placeholder={this.t('enterEmail')}
                    value={email}
                    onChange={this.handleEmailChange}
                    onFocus={this.handleEmailFocus}
                    className="quest-email-input"
                  />
                  {emailError && (
                    <p className="quest-email-error">{emailError}</p>
                  )}
                  <button 
                    type="submit" 
                    className="quest-cta-button email-cta"
                    data-fast-goal="clicked_create_account_quest"
                  >
                    {this.t('createAccount')}
                  </button>
                </form>
              </div>
            ) : (
              <div className="quest-email-success">
                <p className="success-message">{this.t('accountCreated')}</p>
                <p className="success-detail">{this.t('notifyYou')} <strong>{email}</strong></p>
              </div>
            )}
          </>
        )}

        <button 
          className="quest-discord-button"
          onClick={this.handleDiscordClick}
          data-fast-goal="clicked_discord_quest"
        >
          <BsDiscord className="discord-icon" />
          {this.t('joinDiscord')}
        </button>
      </div>
    );
  };

  // Render language modal
  renderLanguageModal = () => {
    if (!this.state.showLanguageModal) return null;

    return (
      <div className="language-modal-overlay">
        <div className="language-modal">
          <div className="language-modal-header">
            <span className="globe-icon">🌍</span>
            <h2>{this.t('welcomeMessage')}</h2>
            <p>{this.t('selectLanguage')}</p>
          </div>
          <div className="language-grid">
            {languageOptions.map((lang) => (
              <button
                key={lang.code}
                className={`language-option ${this.state.language === lang.code ? 'selected' : ''}`}
                onClick={() => this.handleLanguageSelect(lang.code)}
                data-fast-goal={`selected_language_${lang.code}`}
              >
                <img 
                  src={lang.flag} 
                  alt={lang.flagAlt}
                  className="flag-img"
                />
                <span className="lang-name">{lang.name}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { currentScreen } = this.state;

    return (
      <div className="wishlist-game-page">
        {this.renderLanguageModal()}

        {this.renderXpBar()}
        
        <div className="quest-screens-container">
          <div 
            className="quest-screens-slider"
            style={{ transform: `translateX(-${currentScreen * 100}%)` }}
          >
            {this.renderScreen0()}
            {this.renderScreen1()}
            {this.renderScreen2()}
            {this.renderScreen3()}
            {this.renderScreen4()}
          </div>
        </div>

        {this.renderProgressDots()}
        {this.renderSteamPopup()}
      </div>
    );
  }
}

export default WishlistGamePage;

